import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FontParametersComponent } from './font-parameters.component';
import {FormFieldModule} from "@shared/components/games";

@NgModule({
  declarations: [FontParametersComponent],
  exports: [FontParametersComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    GamesSharedModule,
    FormFieldModule,
  ],
})
export class FontParametersModule {}
